export default __webpack_public_path__ + "static/media/GigLinked_i-am-musician-2.319c9b96.svg";